import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { propTypes as skillPropTypes } from 'shared/proptypes/Skill';
import Tag from 'shared/components/Tag';
import styles from './styles.module.scss';

const AddSkillToProfile = ({ entity, setModalData }) => {
  const { t } = useTranslation('userportal');

  const handleSkillClick = () => {
    const newLevel = entity.levelId < 3 ? entity.levelId + 1 : 1;
    setModalData(prev => ({
      ...prev,
      entity: {
        ...prev.entity,
        levelId: newLevel
      }
    }));
  };

  if (!entity) {
    return null;
  }

  return (
    <div>
      <p>
        {t('page.job.add_skillToProfileDescription')}
      </p>
      <div className={styles.tagLine}>
        <Tag
          noTooltip
          slug={entity.slug}
          type="skill"
          level={entity.soft ? undefined : entity.levelId}
          kind="profile-form"
          onClick={entity.soft ? undefined : handleSkillClick}
        >
          {entity.title}
        </Tag>
      </div>
      {!entity.soft && (
        <>
          <p>
            {t('page.job.add_skillToProfileDescription2')}
          </p>
          <p>
            <strong>{t('page.job.selectedLevel')}</strong>: {t(`common:tag.level-${entity.levelId}`)}
          </p>
        </>
      )}
    </div>
  );
};

AddSkillToProfile.propTypes = {
  entity: PropTypes.shape(skillPropTypes),
  setModalData: PropTypes.func
};

AddSkillToProfile.defaultProps = {
  entity: null,
  setModalData() {}
};

export default AddSkillToProfile;
